import { useEffect, useState } from 'react';

//components
import LanguageSettingsTable from '../elements/languages/LanguageSettingsTable'
import { INotificationBar, NotificationType, defaultSettings } from  '@/components/elements/languages/NotificationBar';
import { BasicButton } from 'thrive-components';

//interfaces
import { IHttpRequest } from  '@/interfaces/IHttp';
import { Language, NotificationStatus } from  '@/interfaces/languages';
import { container, TYPES } from  '@/inversifyconfig/container.config';
import {getLanguageSettings} from "../../api/languages";


const LanguageSettings = ({close, language}:{close: (notif:INotificationBar) => void, language?:Language}) => {
    const httpCall = container.get<IHttpRequest>(TYPES.IHttpRequest);
    const [formTouched, setFormTouched] = useState<boolean>(false);
    const [settingsSelection, setSettingsSelection] = useState<number | undefined>(undefined);

    useEffect(() => {
        getLanguageSettings(language?.languageId)
        .then((({data}: {data: {languageSettingOption: number}}) => {
            setSettingsSelection(data.languageSettingOption)
        }));
    }, [])

    function setSelection(selection:number){
        setSettingsSelection(selection);
        setFormTouched(true);
    }

    function save(){
        if (formTouched){
            httpCall.put(`admin/languages/${language?.languageId}/settings`, {
                languageSettingOption: settingsSelection
            })
            .then(() => {
                close({
                    show:true, 
                    notificationStatus:NotificationStatus.success, 
                    msg:`😁 ${language ? language.name : ''} language setting was successfully saved!`, 
                    notificationType:NotificationType.settings
                })
            })
            .catch(() => {
                close({
                    show:true, 
                    notificationStatus:NotificationStatus.error, 
                    msg:`😱 ${language ? language.name : ''} language setting failed to save!`, 
                    notificationType:NotificationType.settings
                })
            });
        } 
    }

    return (
        <div className='languageModal LanguageSettings'>
            <h2 className="settings-header">Language Settings: {language ? language.name : ''}</h2>

            <LanguageSettingsTable 
                language={language} 
                settingsSelection={settingsSelection} 
                setSettingsSelection={setSelection} 
            />

            <div className='controls-container'> 
                <BasicButton 
                    className={`${!formTouched ? 'disabled' : ''}`}
                    content={"Save"} 
                    ariaLabel={'Save Changes'}
                    onButtonClick={save}
                />

                <BasicButton 
                    className={`cancel`}
                    content={"Cancel"} 
                    ariaLabel={'Cancel'}
                    onButtonClick={() => close(defaultSettings)}
                />
            </div>
        </div>
    );
};

export default LanguageSettings;